<template>
	<div>
		<action-sidebar title="Editar Template" :value="value" @close-modal="closeModal">
			<v-layout wrap pa-5>
				<v-flex xs12 mb-3>
					<label>Nombre template
						<v-text-field solo class="body-1" hide-details label="Nombre del template" required
							v-model="data.name" :error="$v.data.name.$error" />
					</label>
				</v-flex>
				<v-flex xs12 mb-3>
					<label>Rubro
						<v-text-field solo class="body-1" hide-details label="Rubro" required readonly
							v-model="data.items.data.name" />
					</label>
				</v-flex>
				<v-flex xs12 mb-3>
					<v-switch class="mt-0" color="base" hide-details :label="labelMaintenance"
						v-model="data.flagMaintenance" />
				</v-flex>
				<v-flex xs12>
					<h3 class="mb-3">End Points</h3>
				</v-flex>
				<v-flex xs5 pb-3>
					<v-text-field background-color="white" solo box class="body-1" hide-details label="Código" required
						v-model="section.code">
					</v-text-field>
				</v-flex>


				<v-flex xs6 pb-3 ml-1>
					<v-text-field background-color="white" solo box class="body-1" hide-details label="Nombre" required
						v-model="section.nameEnd">
					</v-text-field>
				</v-flex>
				<v-flex xs9 pb-3>
					<v-text-field background-color="white" solo box class="body-1" hide-details label="End Point"
						required v-model="section.domain">
					</v-text-field>
				</v-flex>


				<v-flex xs3>
					<v-btn class="pa-2 px-3" color="primary" small
						:disabled="!section.domain && !section.nameEnd && !section.code" @click.native="addDomain">
						Agregar
					</v-btn>
				</v-flex>

				<v-flex xs12 mb-3>
					<label>Contador uso de IA
						<v-text-field solo class="body-1" hide-details label="Contador" type="number"
							v-model="data.countAllow" />
					</label>
				</v-flex>



				<app-table :input-search="false" :include-filter="false" :columns="columns" :rows="rows">
					<template slot="rows" slot-scope="props">
						<td class="is-not-selectable" v-show="showRow(columns, 1)">
							{{ props.row.code }}
						</td>
						<td v-show="showRow(columns, 2)">
							{{ props.row.name }}
						</td>
						<td v-show="showRow(columns, 3)">
							{{ props.row.endPoint }}
						</td>
						<td v-show="showRow(columns, 4)">
							<app-tooltip-button color="red" icon="delete" text="Eliminar"
								@click-icon="deleteRow(props.row)" />
						</td>
					</template>
				</app-table>
			</v-layout>
			<section class="modal-filter-footer">
				<modal-sidebar-button :is-loading="$v.$invalid" :on-run-service="loading"
					@accept-button-clicked="sendData" @cancel-button-clicked="closeModal" />
			</section>
		</action-sidebar>
	</div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import actionSidebar from '@/components/shared/action-sidebar';
import appTooltipButton from '@/components/shared/app-tooltip-button';

function created() {
	this.editTemplate();
}

async function editTemplate() {
	try {
		const headers = {
			Accept: `${process.env.ACCEPT_SERVICE_V2}`,
		};
		const response = await this.$http.get(`template/${this.id}`, { headers });
		this.data = response.data.data;
		console.log(this.data.items.data.name);
		this.rows = this.data.settings && this.data.settings.domains ?
			this.data.settings.domains : [];
	} catch (error) {
		this.showError();
	}
}

function deleteRow({ id }) {
	const findIndex = this.rows.findIndex(p => p.id === id);
	if (findIndex > -1) {
		this.rows.splice(findIndex, 1);
	}
}

function validations() {
	return {
		data: {
			name: { required },
		},
	};
}

function closeModal() {
	this.loading = true;
	this.goTo('page-template', { params: { projectId: this.projectId } });
	this.loading = false;
}

function addDomain() {
	this.rows.push({
		id: Math.floor(Math.random() * 10000) + 1,
		code: this.section.code,
		name: this.section.nameEnd,
		endPoint: this.section.domain,
	});
	this.section = {
		code: '',
		nameEnd: '',
		domain: '',
	};
}

async function sendData() {
	const headers = {
		Accept: `${process.env.ACCEPT_SERVICE_V2}`,
	};
	const body = {
		name: this.data.name,
		description: this.data.description,
		flagMaintenance: this.data.flagMaintenance,
		countAllow: this.data.countAllow ? this.data.countAllow : 30,
		settings: {
			domains: this.rows,
		},
	};
	const response = await this.$http.put(`template/${this.id}`, body, { headers });
	this.data = response.data.data;
	this.showNotification('El template fue actualizdo correctamente.');
	this.closeModal();
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Código', checked: true, visible: true },
			{ id: 2, name: 'Nombre', checked: true, visible: true },
			{ id: 3, name: 'End Point', checked: true, visible: true },
			{ id: 4, name: 'Acción', checked: true, visible: true },
		],
		section: {},
		data: {
			items: {
				data: {
					name: '',
				},
			},
			code: '',
			nameEnd: '',
			flagMaintenance: false,
		},
		loading: false,
		value: true,
		model: {
			name: '',
		},
		rows: [],
	};
}

export default {
	name: 'page-template-edit-name',
	created,
	components: {
		actionSidebar,
		appTooltipButton,
	},
	computed: {
		labelMaintenance() {
			return this.data.flagMaintenance ? 'Activar mantenimiento' : 'Desactivar mantenimiento';
		},
	},
	methods: {
		addDomain,
		closeModal,
		deleteRow,
		editTemplate,
		sendData,
	},
	data,
	props: {
		id: {
			type: [Number, String],
		},
		projectId: {
			type: [Number, String],
		},
	},
	validations,
};
</script>

<style lang="scss" scoped>
.btn-add {
	background: map-get($colors, tab);
	color: white;
	border-radius: 5px;
	margin: 5px;
	padding: 5px 19px;
}
</style>


// WEBPACK FOOTER //
// src/pages/template/page-template-edit-name.vue